import { toTitleCase } from '@mobi/utils/string'
import type { KambiHistoryCoupon } from '@mobi/api-types/kambi'
import type { BetLoopKambiShareCoupon } from '@core/Areas/BetLoop/types'
import { getKambiCouponBetType } from './getKambiCouponBetType'

type KambiCoupon = KambiHistoryCoupon | BetLoopKambiShareCoupon

export const getKambiCouponDetailsForTracking = (coupon: KambiCoupon) => {
  const bet = getKambiCouponBetType(coupon)
  const criterion = coupon.betOffers[0]?.criterion
  const betType =
    bet === 'single' && criterion ? criterion : bet === 'same-game-multi' ? bet : `sports-${bet}`

  const events = coupon.events ?? []
  if (events.length === 0) {
    return { betType, sport: undefined, league: undefined, match: undefined }
  }

  /** If the preceding category is a combination the rest can be undefined */
  const sport = getSportCode(events)

  if (sport === 'Combination') {
    return { betType, sport, league: undefined, match: undefined }
  }

  const league = events.some(
    event =>
      event.eventGroups[event.eventGroups.length - 1].name !==
      events[0].eventGroups[events[0].eventGroups.length - 1].name
  )
    ? 'Combination'
    : events[0].eventGroups[events[0].eventGroups.length - 1].name

  if (league === 'Combination') {
    return { betType, sport, league, match: undefined }
  }

  const match = events.some(event => event.eventName !== events[0].eventName)
    ? 'Combination'
    : events[0].eventName

  return { betType, sport, league, match }
}

// =============
// Local Helpers
// =============

const getSportCode = (events: KambiHistoryCoupon['events']): string => {
  return events.some(event => event.sport?.toLowerCase() !== events[0].sport?.toLowerCase())
    ? 'Combination'
    : toTitleCase(events[0].sport)
}
